var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.component,
    {
      tag: "component",
      class: [
        "banner-details",
        {
          "-link": _vm.component !== "div",
          "-result": _vm.isResult
        }
      ],
      attrs: { href: _vm.href, target: _vm.target, to: _vm.to }
    },
    [
      _vm.isResult
        ? _c("c-card", {
            staticClass: "card",
            style: { backgroundImage: "url(" + _vm.banner.image + ")" },
            nativeOn: {
              click: function($event) {
                return _vm.handleAnalytics("Banners")
              }
            }
          })
        : _c("picture", { staticClass: "content" }, [
            _c("source", {
              attrs: { srcset: _vm.banner.image, media: "(min-width: 769px)" }
            }),
            _vm._v(" "),
            _c("img", {
              ref: "image",
              staticClass: "image",
              attrs: { src: _vm.banner.image_secondary, alt: _vm.banner.name },
              on: {
                load: _vm.change,
                click: function($event) {
                  return _vm.handleAnalytics("banner-principal")
                }
              }
            })
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00ab0263", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00ab0263","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner/BannerDetails.vue
// module id = 2121
// module chunks = 1610